import Application from "services/applications/Application.service"

let officerInfo = JSON.parse(localStorage.getItem("authUser"))
let appService = new Application(officerInfo)

class ReviewController {
  async reviewOfficer(values) {
    if (values.comment_to_applicant === undefined) {
      values.comment_to_applicant = ""
    }
    let response = await appService.reviewApplicationOfficer(values)
    // console.log(response)
    if (response.status) {
      let message = "Review successful. Action -> "

      if (values.decision_code === "010") {
        message = message + "Propose to Approve"
      } else if (values.decision_code === "011") {
        message = message + "Propose to Reject"
      } else if (values.decision_code === "012") {
        message = message + "Return to applicant"
      }
      // alert(message)
      //setreviewSuccess(true)
      return { status: true, message: message }
    } else {
      //seterror(response.message)
      return { status: false, message: response.message }
    }
  }

  async reviewHead(values) {
    // console.log(values)
    if (values.comment_to_applicant === undefined) {
      values.comment_to_applicant = ""
    }
    let response = await appService.reviewApplicationHead(values)
    if (response.status) {
      let message = "Review successful. Action -> "

      if (values.decision_code === "010") {
        message = message + "Propose to Approve"
      } else if (values.decision_code === "011") {
        message = message + "Propose to Reject"
      } else if (values.decision_code === "008") {
        message = message + "Send back to Officer"
      }
      // alert(message)
      return { status: true, message: message }
    } else {
      //seterror(response.message)
      return { status: false, message: response.message }
    }
  }

  async reviewDirector(values) {
    let response = await appService.reviewApplicationDirector(values)
    if (response.status) {
      let message = "Review successful. Action -> "

      if (values.decision_code === "006") {
        message = message + "Approve"
      } else if (values.decision_code === "008") {
        message = message + "Send back to Head"
      } else if (values.decision_code === "009") {
        message = message + "Reject"
      }
      // alert(message)
      return { status: true, message: message }
    } else {
      //seterror(response.message)
      return { status: false, message: response.message }
    }
  }
}

export default ReviewController
